export default {
  // 直播间详细信息接口
  getLiveRoomInfoById: '/member/anonymous/amc/getLiveroomInfo',
  // 直播间互动接口
  listGuestReviewByLiveroomid: '/member/anonymous/amc/listGuestReviewByLiveroomid',
  // 获取直播间参与人数
  getOnAirLiveRoomPartData: '/member/anonymous/amc/getOnAirLiveRoomPartData',
}